import { render, staticRenderFns } from "./restaurantDetail.vue?vue&type=template&id=8126c27a&scoped=true&"
import script from "./restaurantDetail.vue?vue&type=script&lang=js&"
export * from "./restaurantDetail.vue?vue&type=script&lang=js&"
import style0 from "./restaurantDetail.vue?vue&type=style&index=0&id=8126c27a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8126c27a",
  null
  
)

export default component.exports